
var service = function($cacheFactory, $http, $httpParamSerializer) {
  var cache = $cacheFactory('request-cache');
  var res = function(httpArgs) {
    var key = httpArgs.method + " " + httpArgs.url;
    if (httpArgs.params) {
      key += "?" + $httpParamSerializer(httpArgs.params);
    }
    if (cache.get(key)) { return cache.get(key); }
    return cache.put(key, $http(httpArgs));
  };
  res.put = function(httpArgs, res) {
    var key = httpArgs.method + " " + httpArgs.url;
    if (httpArgs.params) {
      key += "?" + $httpParamSerializer(httpArgs.params);
    }
    cache.put(key, res);
  }
  return res;
};

service.$inject = ['$cacheFactory', '$http', '$httpParamSerializer'];

tiz.service('CachedRequest', service);
